export const pageSize = { pageSize: 50, pageIndex: 0 };